import type { ProductListRes } from "../types/product";

export function getNextProductListPageParam(lastPage: ProductListRes, allPages: ProductListRes[]) {
  const loaded = allPages.reduce((n, p) => n + p.list.length, 0);
  if (loaded < lastPage.size) {
    return allPages.length + 1;
  }
  return undefined;
}
